import React from "react";
import classNames from "classnames";
import { ReactSVG } from "react-svg";
import { map, isObject } from "lodash";

import { Link } from "../Link";
import { Typography } from "../Typography";
import { SocialNetwork } from "@/types/qr";
import { IconItem, IconListProps } from "./types";

import { checkValidURL } from "@/utils/formHelper";


import "./styles.scss";
export const IconList = ({
  center,
  items,
  compact,
  column,
  iconItem,
  uncheckValidURL,
  semibold,
  tag,
}: IconListProps) => {
  const classnames = classNames(`IconList`, {
    "IconList--center": center,
    "IconList--compact": compact,
    "u-flex-column": column,
  });

  const checkURL = (link): string =>
    uncheckValidURL ? link : checkValidURL(link);

  return (
    <div data-testid="IconList" className={classnames}>
      {!iconItem ? (
        map(items as SocialNetwork[] | string[], (item, i: number) =>
          isObject(item) ? (
            <Link
              key={i}
              className={`IconList__item ${
                (item as SocialNetwork).mod ? "IconList__item--mod" : ""
              }`}
              href={checkValidURL((item as SocialNetwork).value) || ""}
              externalLink
              aria-label="iconList-item-link"
            >
              <ReactSVG
                className="IconList__svg"
                src={`/svg/icon-${(item as SocialNetwork).id}${
                  (item as SocialNetwork).mod ? (item as SocialNetwork).mod : ""
                }.svg`}
              />
            </Link>
          ) : (
            <span
              className="IconList__item"
              key={i}
              aria-label="iconList-item-span"
            >
              <ReactSVG
                className="IconList__svg"
                src={`/svg/icon-${item}.svg`}
                role="img"
                aria-label="iconList-item-svg"
              />
            </span>
          )
        )
      ) : (
        <div className="IconItem__container">
          <div>
            <ReactSVG
              className="IconList__svg"
              src={`/svg/icons/${(items as IconItem).icon}.svg`}
              role="img"
              aria-label="iconList-icon-svg"
            />
          </div>
          <div className="content">
            {(items as IconItem).title && (
              <Typography
                Tag={tag || "p"}
                size="m"
                classname={
                  semibold ? "IconItem__title u-semibold" : "IconItem__title"
                }
              >
                {(items as IconItem).title}
              </Typography>
            )}
            {(items as IconItem).link ? (
              <Link
                className="IconItem__link"
                href={checkURL((items as IconItem).link) || ""}
                externalLink
              >
                {(items as IconItem).subtitle}
              </Link>
            ) : (
              <>
                {(items as IconItem).subtitle && (
                  <Typography Tag="p" size="s" classname="IconItem__subtitle">
                    {(items as IconItem).subtitle}
                  </Typography>
                )}
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
};
